import installationInstructions from './installationInstructions';

const petCameraCategoryContent = {
  installationInstructions
}

export { petCameraCategoryContent };
